import React from 'react';

import Icon from '@ant-design/icons';
import ShareIcon from '@icons/sankey/share.svg';

interface IShareButton {
  onClick?: () => void;
  disabled?: boolean;
}

const ShareButton: React.FC<IShareButton> = ({ disabled, onClick }) => {
  return (
    <Icon
      disabled={disabled}
      component={ShareIcon}
      style={{
        height: 28,
        width: 28,
        margin: '3px 0px 0px 12px',
        border: `1px solid ${disabled ? 'rgba(0, 0, 0, 0.45)' : '#0046FF'}`,
        borderRadius: '2px',
        color: disabled ? 'rgba(0, 0, 0, 0.45)' : '#0046FF',
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
      }}
      onClick={() => !disabled && onClick?.()}
    />
  );
};

export default ShareButton;
